// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WinnerList_auth-card-body__d2YsR {
  padding: 20px;
}
.WinnerList_table-card-container__4y2uc {
  overflow: auto;
  font-size: 13px;
  color: #000;
  max-height: 500px;
}
.WinnerList_table-card-container__4y2uc ul:first-child {
  position: sticky;
  top: 0;
  z-index: 40;
}
.WinnerList_table-card-container__4y2uc ul:first-child li {
  background-color: #e0f2fe;
}
.WinnerList_table-header__CDDXf,.WinnerList_table-body__ta5ew {
  display: flex;
  margin-bottom: 10px;
}
.WinnerList_table-header__CDDXf li:first-child, .WinnerList_table-body__ta5ew li:first-child {
  flex: 0 0 50px;
  border-radius: 10px 0 0 10px;
}
.WinnerList_table-header__CDDXf li:last-child, .WinnerList_table-body__ta5ew li:last-child {
  flex: 0 0 150px;
  border-radius: 0 10px 10px 0;
}
.WinnerList_table-header__CDDXf li:nth-last-child(2),.WinnerList_table-body__ta5ew li:nth-last-child(2) {
  flex: 0 0 100px;
}
.WinnerList_table-header__CDDXf li:nth-child(2), .WinnerList_table-body__ta5ew li:nth-child(2) {
  flex: 0 0 120px;
}
.WinnerList_table-header__CDDXf li:nth-child(3),.WinnerList_table-body__ta5ew li:nth-child(3) {
  flex: 0 0 120px;
}
.WinnerList_table-header__CDDXf li {
  flex: 0 0 100px;
  padding: 15px;
  white-space: nowrap;
}

.WinnerList_table-body__ta5ew li {
  background-color: var(--main-color);
  flex: 0 0 100px;
  padding: 15px;
  white-space: nowrap;
  color: #FFF;
}

/* table-body */
/* Screen Width 1281px to Higher Resolution Desktops
--------------------------------------------------------------------------- */
@media (min-width: 1281px) {
}

/* Laptop and Desktops
---------------------------------------------------------------------------- */
@media (min-width: 1025px) and (max-width: 1280px) {
}

/* Tablet and IPad (portrait)
----------------------------------------------------------------------------- */
@media (min-width: 768px) and (max-width: 1024px) {
}

/* Tablet and IPad (landscape)
----------------------------------------------------------------------------- */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
}

/* Low Resolution Tablet and Mobile (landscape)
----------------------------------------------------------------------------- */
@media (min-width: 481px) and (max-width: 767px) {
  .WinnerList_table-card-container__4y2uc {
    max-height: 450px;
  }
}

/* Smartphones Mobiles (landscape)
----------------------------------------------------------------------------- */
@media (min-width: 320px) and (max-width: 480px) {
  .WinnerList_table-card-container__4y2uc {
    max-height: 400px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/WinnerList.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA,eAAe;AACf;6EAC6E;AAC7E;AACA;;AAEA;8EAC8E;AAC9E;AACA;;AAEA;+EAC+E;AAC/E;AACA;;AAEA;+EAC+E;AAC/E;AACA;;AAEA;+EAC+E;AAC/E;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;+EAC+E;AAC/E;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".auth-card-body {\n  padding: 20px;\n}\n.table-card-container {\n  overflow: auto;\n  font-size: 13px;\n  color: #000;\n  max-height: 500px;\n}\n.table-card-container ul:first-child {\n  position: sticky;\n  top: 0;\n  z-index: 40;\n}\n.table-card-container ul:first-child li {\n  background-color: #e0f2fe;\n}\n.table-header,.table-body {\n  display: flex;\n  margin-bottom: 10px;\n}\n.table-header li:first-child, .table-body li:first-child {\n  flex: 0 0 50px;\n  border-radius: 10px 0 0 10px;\n}\n.table-header li:last-child, .table-body li:last-child {\n  flex: 0 0 150px;\n  border-radius: 0 10px 10px 0;\n}\n.table-header li:nth-last-child(2),.table-body li:nth-last-child(2) {\n  flex: 0 0 100px;\n}\n.table-header li:nth-child(2), .table-body li:nth-child(2) {\n  flex: 0 0 120px;\n}\n.table-header li:nth-child(3),.table-body li:nth-child(3) {\n  flex: 0 0 120px;\n}\n.table-header li {\n  flex: 0 0 100px;\n  padding: 15px;\n  white-space: nowrap;\n}\n\n.table-body li {\n  background-color: var(--main-color);\n  flex: 0 0 100px;\n  padding: 15px;\n  white-space: nowrap;\n  color: #FFF;\n}\n\n/* table-body */\n/* Screen Width 1281px to Higher Resolution Desktops\n--------------------------------------------------------------------------- */\n@media (min-width: 1281px) {\n}\n\n/* Laptop and Desktops\n---------------------------------------------------------------------------- */\n@media (min-width: 1025px) and (max-width: 1280px) {\n}\n\n/* Tablet and IPad (portrait)\n----------------------------------------------------------------------------- */\n@media (min-width: 768px) and (max-width: 1024px) {\n}\n\n/* Tablet and IPad (landscape)\n----------------------------------------------------------------------------- */\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n}\n\n/* Low Resolution Tablet and Mobile (landscape)\n----------------------------------------------------------------------------- */\n@media (min-width: 481px) and (max-width: 767px) {\n  .table-card-container {\n    max-height: 450px;\n  }\n}\n\n/* Smartphones Mobiles (landscape)\n----------------------------------------------------------------------------- */\n@media (min-width: 320px) and (max-width: 480px) {\n  .table-card-container {\n    max-height: 400px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"auth-card-body": `WinnerList_auth-card-body__d2YsR`,
	"table-card-container": `WinnerList_table-card-container__4y2uc`,
	"table-header": `WinnerList_table-header__CDDXf`,
	"table-body": `WinnerList_table-body__ta5ew`
};
export default ___CSS_LOADER_EXPORT___;
